// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://dtp-mining-v2.vertuoz.fr/api-mobile/v1',
  //apiUrl: 'http://dtp.com/api-mobile/v1',
  appVersionSuffix: '',
  webAppVersion: '0.10.10',
  /** Taille des marqueurs sur un plan dans les composants concernés */
  marqueurPlanSize: 32,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
